<script>
import { scrollToAnchor } from '@/utils/scroll-to-anchor';

export default {
  name: 'Button',
  props: {
    'glitch-hover': Boolean,
    fluid: Boolean,
    href: String,
  },
  methods: {
    scrollToAnchor,
    handleClick(event) {
      scrollToAnchor(event);

      this.$emit('click', event);
    },
  },
};
</script>

<template>
  <a
    class="button"
    v-bind:class="{'glitch-hover': glitchHover, button_fluid: fluid}"
    :href="href"
    v-on:click="handleClick"
  >
    <span class="button__icon">
      <slot name="icon"></slot>
    </span>
    <slot></slot>
  </a>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.button {
  display: inline-block;
  padding: 15px 40px;
  text-align: center;
  font-size: var(--font-size-s);
  text-decoration: none;
  font-weight: bold;
  color: var(--main-dark);
  background: var(--main-bright);
  cursor: pointer;
  box-sizing: border-box;
}

.button_fluid {
  width: 100%;
}

.button__icon {
  & > * {
    margin-right: 12px;
  }
}

.glitch-hover {
  transform: translate3d(0,0,0);

  transition: box-shadow 0.5s ease-in-out;

  $hover-shift: 5px;
  $hover-shift-negative: -$hover-shift;

  &:hover {
    text-decoration: none;
    box-shadow: $hover-shift-negative $hover-shift-negative 0 $hover-shift #fb0047,
    $hover-shift $hover-shift 0 $hover-shift #0ffbf9;
  }
}
</style>
